import open from "webmodals/open";
import templateUrl from 'emun.customer/customer-vendor/customer-vendor.htm'
import controller from "emun.customer/customer-vendor/customer-vendor.controller";

export default ({
  size = "md",
  backdrop = "true",
  placement = "center",
  preventAutoHeight = true,
  customer = customer,
  request = request,
  type = type,
  saveType = daveType,
  title = `Customer Vendor`
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    resolve: {
      preventAutoHeight: () => preventAutoHeight,
      title: () => title,
      customer: () => customer,
      request: () => request,
      type: () => type,
      saveType: () => saveType
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;

